module.exports = __webpack_public_path__ + "static/img/solve6.d0f5349.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/solve6.png
// module id = oz1D
// module chunks = 1